import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class PatTry extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.PatTry;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        ruleContext.PAT = true;
        ruleContext.setResetField(true);
        gameContext.triggerPAT = false;
        this.kickoffContextChanges(gameContext);
    }

    kickoffContextChanges() {}
}
